import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  // Mobile menu click 
m_menuOpen(){
  let activeCheck = document.querySelector(".mainMenuWrap");
  if(!activeCheck.classList.contains("active")){
    activeCheck.classList.add("active");
  }else{
    activeCheck.classList.remove("active");
  }
}

m_closeMenu(){
  document.querySelector(".mainMenuWrap").classList.remove("active");
}

}
